import { AlertTriangle, TrendingDown, Clock, Target } from "lucide-react";

export default function CostSection() {
  const costs = [
    "Uma meta mal dimensionada.",
    "Um crescimento não suportado pela estrutura.",
    "Um backlog acumulado silenciosamente.",
    "Um erro estratégico percebido tarde demais.",
  ];

  return (
    <section
      id="cost"
      className="relative py-16 md:py-32 bg-[#0F1115]"
      data-testid="cost-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            Reflexão
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB]">
            Quanto custa decidir <span className="text-[#F59E0B]">no escuro?</span>
          </h2>
        </div>

        {/* Content */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-8 md:p-10">
            {/* Cost Items */}
            <div className="space-y-4 mb-8">
              {costs.map((cost, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3"
                  data-testid={`cost-item-${index}`}
                >
                  <div className="w-2 h-2 bg-[#EF4444] rounded-full flex-shrink-0" />
                  <p className="text-[#E5E7EB]">{cost}</p>
                </div>
              ))}
            </div>

            {/* Divider */}
            <div className="w-16 h-px bg-[#2A2F38] mx-auto my-8" />

            {/* Statement */}
            <div className="text-center">
              <p className="text-[#9CA3AF] text-base md:text-lg mb-4">
                O risco estrutural quase nunca aparece no caixa primeiro.
              </p>
              <p className="text-[#E5E7EB] text-base md:text-lg font-medium mb-2">
                Ele aparece na operação —
              </p>
              <p className="text-[#E5E7EB] text-base md:text-lg font-medium mb-6">
                nos prazos que começam a não ser cumpridos.
              </p>
              
              <div className="bg-[#0F1115] border border-[#F59E0B]/30 rounded-sm p-6 mt-6">
                <p className="text-[#9CA3AF] mb-2">
                  O investimento no KpAction não é custo.
                </p>
                <p className="text-[#F59E0B] text-lg font-medium">
                  É proteção contra erro estrutural acumulado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
